import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { NotFoundComponent } from './notfound/notfound.component';
import { NotificationComponent } from './common/notification/notification.component';
import { SelectLobComponent } from './auth/lob/select-lob.component';
import { AuthGuard, configurationGuard } from './auth.gaurd';

export const routes: Routes = [
    { path: '', component: LoginComponent },
    { path: 'login', component: LoginComponent },
    { path: 'select-lob', component: SelectLobComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'change-password', component: ChangePasswordComponent },
    { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] },
    { path: 'users', loadChildren: () => import('./users/users.module').then(m => m.UsersModule), canActivate: [AuthGuard] },
    { path: 'store', loadChildren: () => import('./store/store.module').then(m => m.StoreModule), canActivate: [AuthGuard] },
    { path: '3pl', loadChildren: () => import('./org/org.module').then(m => m.OrgModule), canActivate: [AuthGuard] },
    { path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule), canActivate: [AuthGuard] },
    { path: 'pallets', loadChildren: () => import('./pallets/pallets.module').then(m => m.PalletsModule), canActivate: [AuthGuard] },
    { path: 'support', loadChildren: () => import('./support/support.module').then(m => m.SupportModule), canActivate: [AuthGuard] },
    { path: 'transfer', loadChildren: () => import('./transfer/transfer.module').then(m => m.TransferModule), canActivate: [AuthGuard] },
    { path: 'configuration', loadChildren: () => import('./config/config.module').then(m => m.ConfigModule), canActivate: [AuthGuard, configurationGuard] },
    { path: 'notifications', component: NotificationComponent, canActivate: [AuthGuard] },
    { path: 'unauthorized-access', component: UnauthorizedComponent},
    { path: 'not-found', component: NotFoundComponent },
    { path: '**', redirectTo: '/not-found' }
];
